import { AxiosInstancePlus } from '@tencent/oneid-request';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';
import type { IMobileChangeParRequest, IMobileChangeParResponse } from '../type';

class PersonApi {
  public axiosInstance: AxiosInstancePlus = http;

  public postMobileChangePar(
    data: IMobileChangeParRequest,
  ): Promise<IResponseType<IMobileChangeParResponse>> {
    return this.axiosInstance.post('admin/v2/person/mobile_change/par', data);
  }
}

export default new PersonApi();
